import { Restrictions } from './restrictions.model';
import { Module } from './module.model';
import { Office } from './office.model';

export interface Client {
  _id?: string;
  name?: string;
  code: string;
  // client_code?: string;
  email?: string;
  phone: string;
  link: string;
  sso?: boolean;
  offices?: Pick<Office, 'name' | 'address' | 'radius' | 'status' | 'id'>[];
  chosen_array_week_day?: number[];
  chosen_array_time?: number[];
  restrictions?: Restrictions;
  logo?: {
    base64: string;
    url: string;
  };
  awards_regulation: {
    url: string;
  };
  privacy_url: string;
  terms_conditions_url: string;
  modules?: Pick<Module, '_id' | 'name' | 'code'>[];
  // description?: string;
  // users?: string[];
}


export interface ClientUserOutput{
  _id: string;
  name: string;
  code: string;
  email: string;
  modules?: Pick<Module, '_id' | 'name' | 'code'>[];

  offices: OfficeUser[];

  logo?: {
    url: string;
  };
  awards_regulation: {
    url: string;
  };
}
export interface OfficeUser{
  id: string;
  full_address: string;
  name: string;
}
